<template>    
  <el-dialog 
    width="420px"
    :title="dialog.title" 
    :visible.sync="dialog.isShow"
    @open='open' >
    <el-form ref="form" :model="form" label-width="80px" size="medium"> 
      <el-form-item label="行业名称">
        <el-input v-model="form.name"></el-input>            
      </el-form-item>
      <el-form-item label="上级行业">
        <el-select v-model="form.parentId" placeholder="请选择行业">
          <el-option
            v-for="item in parentIndustry"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="显示顺序">
        <el-input-number v-model="form.sort"  :min="1" :max="1000" label="描述文字"></el-input-number>
      </el-form-item>
      <el-form-item label="商城显示">    
        <el-switch v-model="form.onlineView" />
      </el-form-item>
      <el-form-item label="上传图标">
        <el-upload
          class="upload-demo"
          :action="uploadUrl"
          :headers="headers"
          :on-success="handleIconSuccess"
          :file-list="fileList">
          <el-button size="small" type="primary">选择文件</el-button>
        </el-upload>
      </el-form-item>  
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialog.isShow = false">取 消</el-button>
      <el-button type="primary" @click="Save">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script  type='text/ecmascript-6'>
export default {
  props:{
    dialog:{}
  },
  data (){
    return {
      form : {},
      parentIndustry:[],
      fileList:[],
      uploadUrl: this.global.serverSrc+'/api/Common/UploadImage',
      headers:{
        Authorization : sessionStorage.getItem('token')
      }
    }
  },  
  components:{
  },
  computed:{
  },
  mounted(){
  },
  methods:{   
    open:function(){      
      console.log("open:"+this.dialog.id)
      var that = this
      this.axios({
        method:'post',
        url:that.global.serverSrc + '/api/Industry/Get',         
        data:{
          id: that.dialog.id
        }
      }).then(function (resp) {
        debugger
        if(resp.data.errorCode==0){
          that.form = resp.data.industry
          that.parentIndustry = resp.data.parentIndustrys
        }else {
          that.$message.warning(resp.data.message);
        }  
      }).catch(resp => {         
        console.log('请求失败：' + resp.message + ',' + resp.stack)
      })
    },
    Save(){
      var that = this
      this.axios({
        method:'post',
        url:that.global.serverSrc + '/api/Industry/Save',         
        data:this.form
      }).then(function (resp) {
        if(resp.data.errorCode==0){
          that.$message.success(resp.data.message);
          that.dialog.isShow = false
          that.$emit('GetData')
        }else {
          that.$message.warning(resp.data.message);
        }  
      }).catch(resp => {         
        console.log('请求失败：' + resp.message + ',' + resp.stack)
      })
    },   
    handleIconSuccess(res, file){
      this.form.Icon= res.fullUrl
    },
  },
  created(){
  
  },
}
</script>